import React, { useEffect, useState, createContext, useContext } from 'react';
interface AdminAuthContextType {
  isAdminAuthenticated: boolean;
  adminLogin: (email: string, password: string) => Promise<boolean>;
  adminLogout: () => void;
  adminUser: AdminUser | null;
}
interface AdminUser {
  email: string;
  name: string;
}
const AdminAuthContext = createContext<AdminAuthContextType | undefined>(undefined);
export function AdminAuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [adminUser, setAdminUser] = useState<AdminUser | null>(null);
  // Check for existing admin session on mount
  useEffect(() => {
    const adminSession = localStorage.getItem('adminSession');
    if (adminSession) {
      try {
        const user = JSON.parse(adminSession);
        setAdminUser(user);
        setIsAdminAuthenticated(true);
      } catch (error) {
        console.error('Failed to parse admin session:', error);
        localStorage.removeItem('adminSession');
      }
    }
  }, []);
  const adminLogin = async (email: string, password: string): Promise<boolean> => {
    // Simulate API call - replace with actual admin authentication
    // For demo purposes, accept any email/password combination
    // In production, this should validate against a secure backend
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 500));
    // For demo: accept any credentials
    // In production: validate against backend API
    const user: AdminUser = {
      email,
      name: email.split('@')[0]
    };
    setAdminUser(user);
    setIsAdminAuthenticated(true);
    localStorage.setItem('adminSession', JSON.stringify(user));
    return true;
  };
  const adminLogout = () => {
    setAdminUser(null);
    setIsAdminAuthenticated(false);
    localStorage.removeItem('adminSession');
  };
  return <AdminAuthContext.Provider value={{
    isAdminAuthenticated,
    adminLogin,
    adminLogout,
    adminUser
  }} data-id="element-4264">
      {children}
    </AdminAuthContext.Provider>;
}
export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (context === undefined) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
}